import styledComponent from 'styled-components';

export const TextFieldStyle = {
  background: 'white',
  maxWidth: '100%',
  borderRadius: '8px',
  marginLeft: '.5rem',
};

export const ContainerTextField = styledComponent.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default { TextFieldStyle, ContainerTextField };
